<script>
    import { randString } from "../../scripts/functions";
    import { getEventsAction } from "../../scripts/utils.js";
    import { current_component, each } from "svelte/internal";
    import CarouselBlock from "../CarouselBlock/CarouselBlock.svelte";
    const events = getEventsAction(current_component);

    export let disabled = false;
    export let blocks = [];
    let currentBlock = 1;
    let previewBlock = currentBlock > 0 ? currentBlock - 1 : blocks.length - 1;
    let nextBlock = currentBlock < blocks.length - 1 ? currentBlock + 1 : 0;
    let localClass;
    let container;
    let isCaught = false;
    let tempPositionX = 0;
    let tempPositionY = 0;
    let transition = false;
    let transitionTimeout = 500;
    let canCaught = true;
    let timer;
    let scrolling = false;

    while (true) {
        let tempClass = "main-carousel-" + randString(5);
        if (document.getElementsByClassName(tempClass).length === 0) {
            localClass = tempClass;
            break;
        }
    }

    function blockRelease(event, touch) {
        if(canCaught && isCaught){
            autoSlide();
            isCaught = false;
            enableScroll();
            let containerWidth = container.clientWidth;
            let X = 0;
            if (touch) {
                X = event.changedTouches[0].clientX;
            } else {
                X = event.x;
            }
            let delta = tempPositionX - X;
            if (Math.abs(delta) > containerWidth * 0.25 && delta < 0) {
                slideBlocks(-1);
            } else if (Math.abs(delta) > containerWidth * 0.25) {
                slideBlocks(1);
            } else {
                transition = true;
                container.style.left = "0px";
                setTimeout(() => {
                    transition = false;
                }, transitionTimeout);
            }
        }
    }

    function blockCaught(event, touch) {
        if(canCaught){
            clearTimeout(timer);
            isCaught = true;
            if (touch) {
                tempPositionX = event.touches[0].clientX;
                tempPositionY = event.touches[0].clientY;
            } else {
                tempPositionX = event.x;
                tempPositionY = event.Y;
            }
        }
    }

    function blockDragging(event, touch) {
        if (isCaught) {
            if (touch) {
                if(Math.abs(tempPositionX - event.touches[0].clientX) > 15){
                    disableScroll(event);
                }
                else{
                    if(Math.abs(tempPositionY - event.touches[0].clientY) > 15 && !scrolling){
                        scrolling = true;
                    }
                }
                if(!scrolling){
                    setValue(event.touches[0].clientX);
                }
            } else if (event.buttons === 1) {
                setValue(event.x);
            }
        }
    }

    function setValue(x) {
        let delta = tempPositionX - x;
        container.style.left = -delta + "px";
    }

    export function slideBlocks(direction) {
        transition = true;
        let containerWidth = container.clientWidth;

        if (direction > 0) {
            container.style.left = -containerWidth + "px";
        } else {
            container.style.left = containerWidth + "px";
        }
        setTimeout(() => {
            transition = false;
            changeBlocks(direction);
        }, transitionTimeout);
    }

    function changeBlocks(direction) {
        if (currentBlock + direction == blocks.length) {
            currentBlock = 0;
        } else if (currentBlock + direction == -1) {
            currentBlock = blocks.length - 1;
        } else {
            currentBlock += direction;
        }
        previewBlock = currentBlock;
        nextBlock = currentBlock;
        canCaught = false;
        setTimeout(() => {
            restorePosition();
        }, transitionTimeout);
    }

    function restorePosition() {
        container.style.left = "0px";
        previewBlock = currentBlock > 0 ? currentBlock - 1 : blocks.length - 1;
        nextBlock = currentBlock < blocks.length - 1 ? currentBlock + 1 : 0;
        setTimeout(() => {
            canCaught = true;
        }, transitionTimeout);
        
    }

    function enableScroll(){
        let r = document.querySelector(':root');
        r.style.setProperty("--touch-action", "unset");
        scrolling = false;
    }

    function disableScroll(event){
        let r = document.querySelector(':root');
        r.style.setProperty("--touch-action", "none");
        if (event.cancelable) {
            event.preventDefault();
        }

    }

    autoSlide();

    function autoSlide(){
        timer = setTimeout(() =>{
            if(!isCaught){
                slideBlocks(1);
            }
            autoSlide();
        }, 5000);
    }

</script>

<div
    class="{localClass} {$$props.class ? $$props.class : ''}"
    class:disabled
    class:transition
    use:events
    on:mousedown={(event) => {
        blockCaught(event, false);
    }}
    on:touchstart={(event) => {
        blockCaught(event, true);
    }}
    on:mouseup={(event) => {
        blockRelease(event, false);
    }}
    on:touchend={(event) => {
        blockRelease(event, true);
    }}
    on:mousemove={(event) => {
        blockDragging(event, false);
    }}
    on:touchmove={(event) => {
        blockDragging(event, true);
    }}
    bind:this={container}
>
    <div class="preview-block">
        <CarouselBlock block={blocks[previewBlock]} />
    </div>

    <div class="current-block">
        <CarouselBlock block={blocks[currentBlock]} />
    </div>

    <div class="next-block">
        <CarouselBlock block={blocks[nextBlock]} />
    </div>
</div>

<style lang="less" global>
    @import "MainCarousel.less";
</style>
